<template>
  <div class="a-pie">
    <canvas :id="id" class="a-pie__canvas" :height="height" />
  </div>
</template>

<script>
import Chart from 'chart.js/auto';

// Pineapple palette for pie slices (matches admin-shared.jsx tokens)
const DEFAULT_COLORS = [
  '#FFC93C', // $p-point   - yellow
  '#3B7BC4', // $p-info    - blue
  '#1E8C66', // $p-ok      - green
  '#C44A3A', // $p-err     - red
  '#1F1B14', // $p-ink     - dark
  '#9C9486', // $p-ink-soft - tan
];

export default {
  name: 'APieChart',
  props: {
    id:     { type: String, default: 'a-pie-chart' },
    height: { type: [String, Number], default: 220 },
    chart:  { type: Object, required: true },
    colors: { type: Array, default: () => DEFAULT_COLORS },
    cutout: { type: [String, Number], default: '55%' },
  },
  data() {
    return { chartInstance: null };
  },
  watch: {
    'chart.datasets.data': { handler() { this.render(); }, deep: true },
    'chart.labels':        { handler() { this.render(); }, deep: true },
  },
  mounted() {
    this.render();
  },
  beforeUnmount() {
    if (this.chartInstance) this.chartInstance.destroy();
  },
  methods: {
    render() {
      const ctx = document.getElementById(this.id);
      if (!ctx) return;

      const existing = Chart.getChart(this.id);
      if (existing) existing.destroy();

      const sliceCount = (this.chart?.datasets?.data || []).length;
      const palette = this.colors.slice(0, sliceCount);

      this.chartInstance = new Chart(ctx.getContext('2d'), {
        type: 'doughnut',
        data: {
          labels: this.chart.labels,
          datasets: [{
            label: this.chart.datasets.label,
            data: this.chart.datasets.data,
            backgroundColor: palette,
            borderColor: '#FFFFFF',
            borderWidth: 3,
            hoverOffset: 8,
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          cutout: this.cutout,
          plugins: {
            legend: { display: false },
            tooltip: {
              backgroundColor: '#1F1B14',
              titleColor: '#FFC93C',
              titleFont: { weight: '700', size: 12 },
              bodyColor: '#FFFFFF',
              bodyFont: { size: 12 },
              padding: 10,
              cornerRadius: 8,
              displayColors: true,
              boxPadding: 6,
            },
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.a-pie {
  position: relative;
  width: 100%;
}
.a-pie__canvas {
  max-width: 100%;
}
</style>
